import { apiClient } from './apiClient';

export interface Notification {
  id: string;
  title: string;
  description: string;
  type: 'info' | 'success' | 'warning' | 'error';
  category: 'appointment' | 'system' | 'approval' | 'report' | 'chat';
  link?: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export const notificationsService = {
  async getAll(): Promise<Notification[]> {
    const response = await apiClient.get('/notifications');
    return response.data || [];
  },

  async markAsRead(id: string): Promise<Notification> {
    const response = await apiClient.patch(`/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.patch('/notifications/read-all');
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/notifications/${id}`);
  },
};

export const adminNotificationsService = {
  async getNotifications(): Promise<Notification[]> {
    const response = await apiClient.get('/admin/notifications');
    return response.data || [];
  },

  async markAsRead(id: string): Promise<Notification> {
    const response = await apiClient.patch(`/admin/notifications/${id}/read`);
    return response.data;
  },
};
